import React, { Component } from 'react';
import  {Link}  from 'react-router-dom';
import Cookies from 'universal-cookie';
import {
  ProSidebar,
  Menu,
  MenuItem,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
  SubMenu
} from 'react-pro-sidebar';
import 'react-pro-sidebar/dist/css/styles.css';

import { FcHome, FcViewDetails, FcAutomotive, FcContacts, FcNews, FcManager,FcDocument } from 'react-icons/fc';
import { FaClinicMedical, FaEnvelopeOpen,FaWrench,FaCarCrash } from 'react-icons/fa';
import ReactTooltip from 'react-tooltip';

import { /*FiHome, FiLogOut,*/ FiArrowLeftCircle, FiArrowRightCircle } from "react-icons/fi";

import './header/Header.css';
import { size } from 'underscore';
// import logo from "../components/images/BG.png";
//import HeaderTop from './top';

// import { relativeTimeRounding } from "moment";
const axios = require('axios');

const cookies = new Cookies();
class Header2 extends Component {
  constructor () {
    super()
   this.state = { isvehicle: false,cdir:'',isvalid: false,headerwidth:"header",imgdiv:"imgdiv",divadmin:"block",divadmin2:"block", divdisplay:"block",menuattendance:"block",menuCollapse: false, changediv: 'container1', logo: config.Appdir+'/images/profile.png', logo2: config.Appdir+'/images/', year: new Date().getFullYear()};
  }

//  componentWillMount () {
  componentDidMount(){
    this.setState({ isvalid: false, isvehicle:false});
    if (!cookies.get('LoginID')) 
    {
      window.location.href = config.Appdir+'/login/';
    } 
    else 
    {
      const ID = cookies.get('LoginID');
      const VH = cookies.get('vh');
      const rn = Math.random(3);
      let sh="none";
      let sh2="none";
      console.log(cookies.get("Admin"));
      if (cookies.get("Admin")==1)
      {
        sh="block";
        sh2="none";
      }
      else if(cookies.get("Admin")==2 )
      {
        sh2="block";
        sh="none";
      }
      else if(cookies.get("Admin")==3 )
      {
        sh="block";
        sh2="block";
      }
      else
      {
        sh="none";
        sh2="none";
      }


/*      const sh = cookies.get("Admin");

      const sh2 = cookies.get("Admin2");
      const sh3 = cookies.get("Admin3");*/

      const auth = cookies.get("Auth");
//      const cnic = cookies.get("cnic");
      let cdir=cookies.get("phpclass");
//      cdir=cdir.substr(0,cdir.length-4)+'/images/' + cookies.get('LoginID') + '.jpg?ver=' + rn ;
      this.setState({ logo2: cdir.substr(0,cdir.length-4)+'/images/' + cookies.get('cnic') + '.jpg?ver=' + rn,isvalid:true,divdisplay: VH,divadmin: sh,divadmin2:sh2,menuattendance:auth});
      

      //this.setState({ logo2: cookies.get("phpclass")+'/images/' + ID + '.jpg?ver=' + rn,isvalid:true,divdisplay: VH,divadmin: sh});
    }
  }

  handler3 () {
    const rn = Math.random(3);
    let cdir=cookies.get("phpclass");
    

//    alert(cookies.get("phpclass")+'/images/' + cookies.get('LoginID') + '.jpg?ver=' + rn );
//    this.setState({ logo2: 'https://poultry-kandns.com/images/' + cookies.get('LoginID') + '.jpg?ver=' + rn });
    this.setState({ logo2: cdir.substr(0,cdir.length-4)+'/images/' + cookies.get('cnic') + '.jpg?ver=' + rn });
  }

menuIconClick=() => {
  this.state.menuCollapse ? this.setState({ menuCollapse: false,imgdiv:"imgdiv",headerwidth:"headerm" }) : this.setState({ menuCollapse: true,imgdiv:"imgdiv2",headerwidth:"header" });
}

render() {
//  const isvalid = this.state.isvalid;
//  const isvehicle = this.state.isvehicle;
  //let rn=Math.random();
  return (
        <div id="header" >
            <ProSidebar  collapsed={this.state.menuCollapse}>
              <SidebarHeader className="sideheader">
                <div className="closemenu" onClick={this.menuIconClick}>
                  {this.state.menuCollapse ? (
                    <FiArrowRightCircle/>
                  ) : (
                    <FiArrowLeftCircle/>
                  )}
                  </div> 
              </SidebarHeader>
              <SidebarContent>
              <img className={this.state.imgdiv} src={this.state.logo2} onError={e => { e.target.src = this.state.logo }} alt="Profile"/>
              <p style={{ textAlign: 'center', width: '100%' }}>{cookies.get('EmpName')} </p>
              <hr className="new5"></hr>
              <Menu>
                  <MenuItem icon={<FcHome size={30}/>} >Home<Link to ="./home" data-tip data-for="homeTip"/></MenuItem>
                  <ReactTooltip id="homeTip" place="top" >Home</ReactTooltip>       
                    <SubMenu title="Admin Karachi" icon={<FcManager size={30}/>}  style={{display:this.state.divadmin}}>
                        <MenuItem >Medical Reimbursement<Link to ="./AdminMedical" data-tip data-for="a1"/></MenuItem>
                        <ReactTooltip id="a1" place="top" effect="solid">Medical reimbursement</ReactTooltip>
                        <MenuItem >Leave management<Link to ="./AdminLeaveManagement" data-tip data-for="a2"/></MenuItem>
                        <ReactTooltip id="a2" place="top" effect="solid">Leave management</ReactTooltip>
                        <MenuItem >Attendance<Link to ="./EmployeeAttendance" data-tip data-for="a3"/></MenuItem>
                        <ReactTooltip id="a3" place="top" effect="solid">Attendance</ReactTooltip>
                        <MenuItem >Vehicle Upkeep <Link to ="./AdminVehicleupkeep" data-tip data-for="a6"/></MenuItem>
                        <ReactTooltip id="a6" place="top" effect="solid">Vehicle Upkeep</ReactTooltip>


                        <MenuItem >Policies/documents<Link to ="./AdminNotification" data-tip data-for="a4"/></MenuItem>
                        <ReactTooltip id="a4" place="top" effect="solid">Policies/documents</ReactTooltip>
                        <MenuItem >News/Notifications<Link to ="./AdminNews" data-tip data-for="a5"/></MenuItem>
                        <ReactTooltip id="a5" place="top" effect="solid">News/Notifications</ReactTooltip>
                        <ReactTooltip id="admin" place="top" effect='solid' >Admin Karachi</ReactTooltip>
                      </SubMenu>
{/*Admin Abbotabad*/}
                      <SubMenu title="Admin Abbotabad" icon={<FcManager size={30}/>}  style={{display:this.state.divadmin}}>
                        <MenuItem >Medical Reimbursement<Link to ="./AdminMedicalAbt" data-tip data-for="aa1"/></MenuItem>
                        <ReactTooltip id="aa1" place="top" effect="solid">Medical reimbursement</ReactTooltip>
                        <MenuItem >Leave management<Link to ="./AdminLeaveManagementABT" data-tip data-for="aa2"/></MenuItem>
                        <ReactTooltip id="aa2" place="top" effect="solid">Leave management</ReactTooltip>
{/*}                        <MenuItem >Attendance<Link to ="./EmployeeAttendance" data-tip data-for="a3"/></MenuItem>
                        <ReactTooltip id="a3" place="top" effect="solid">Attendance</ReactTooltip>
                        <MenuItem >Policies/documents<Link to ="./AdminNotification" data-tip data-for="a4"/></MenuItem>
                        <ReactTooltip id="a4" place="top" effect="solid">Policies/documents</ReactTooltip>
                        <MenuItem >News/Notifications<Link to ="./AdminNews" data-tip data-for="a5"/></MenuItem>
                  <ReactTooltip id="a5" place="top" effect="solid">News/Notifications</ReactTooltip>*/}
                  <ReactTooltip id="admina" place="top" effect='solid' >Admin</ReactTooltip>
                      </SubMenu>
{/*Admin Wahcannt*/}
                      <SubMenu title="Admin Wah cantt" icon={<FcManager size={30}/>}  style={{display:this.state.divadmin}}>
                        <MenuItem >Medical Reimbursement<Link to ="./AdminMedicalWah" data-tip data-for="wa1"/></MenuItem>
                        <ReactTooltip id="wa1" place="top" effect="solid">Medical reimbursement</ReactTooltip>
                        <MenuItem >Leave management<Link to ="./AdminLeaveManagementWAH" data-tip data-for="wa2"/></MenuItem>
                        <ReactTooltip id="wa2" place="top" effect="solid">Leave management</ReactTooltip>
{/*}                        <MenuItem >Attendance<Link to ="./EmployeeAttendance" data-tip data-for="a3"/></MenuItem>
                        <ReactTooltip id="a3" place="top" effect="solid">Attendance</ReactTooltip>
                        <MenuItem >Policies/documents<Link to ="./AdminNotification" data-tip data-for="a4"/></MenuItem>
                        <ReactTooltip id="a4" place="top" effect="solid">Policies/documents</ReactTooltip>
                        <MenuItem >News/Notifications<Link to ="./AdminNews" data-tip data-for="a5"/></MenuItem>
                <ReactTooltip id="a5" place="top" effect="solid">News/Notifications</ReactTooltip>*/}
                        <ReactTooltip id="adminw" place="top" effect='solid' >Admin</ReactTooltip>
                      </SubMenu>

                  <MenuItem icon={<FaEnvelopeOpen size={30}/>}>My Payslip <Link to ="./paylist" data-tip data-for="payslipTip"/></MenuItem>
                  <ReactTooltip id="payslipTip" place="top" effect="solid"> My payslip</ReactTooltip>

{/*}                  <MenuItem icon={<FcDocument size={30}/>}>Tax certificate <Link to ="./Taxcertificate" data-tip data-for="tax"/></MenuItem>
                  <ReactTooltip id="tax" place="top" effect="solid"> Tax certificate</ReactTooltip>
                  */}

                    <SubMenu title="Leave and attendance" icon={<FcViewDetails size={30}/>} >
                     <ReactTooltip id="leaveTip" place="top" effect="solid">Leave</ReactTooltip>

                        <MenuItem >Balance/Detail <Link to ="./leave"  data-tip data-for="leave1Tip"/></MenuItem>
                        <ReactTooltip id="leave1Tip" place="top" effect="solid"> Balance/Detail</ReactTooltip>

                        <MenuItem >Leave form (self) <Link to ="./LeaveApplicationSelf" data-tip data-for="leave2Tip"/></MenuItem>
                        <ReactTooltip id="leave2Tip" place="top" effect="solid">Leave form (self) </ReactTooltip>

                        <MenuItem >Leave form (other) <Link to ="./LeaveApplicationOther" data-tip data-for="leave3Tip"/></MenuItem>
                        <ReactTooltip id="leave3Tip" place="top" effect="solid">Leave form (other)</ReactTooltip>

                        <MenuItem >Compensatory Leave <Link to ="./LeaveCompensatory" data-tip data-for="leave33Tip"/></MenuItem>
                        <ReactTooltip id="leave33Tip" place="top" effect="solid">Compensatory Leave</ReactTooltip>

                        <MenuItem >Application detail <Link to ="./leaveapplist" data-tip data-for="leave4Tip"/></MenuItem>
                        <ReactTooltip id="leave4Tip" place="top" effect="solid">Application detail</ReactTooltip>

                        <MenuItem >Attendance detail <Link to ="./Attendance" data-tip data-for="leave5Tip"/></MenuItem>
                        <ReactTooltip id="leave5Tip" place="top" effect="solid">Attendance detail</ReactTooltip>

                        <MenuItem >Virtual Attendance <Link to ="./VirtualAttendance" data-tip data-for="leave6Tip"/></MenuItem>
                        <ReactTooltip id="leave6Tip" place="top" effect="solid">Virtual Attendance</ReactTooltip>

{/*}                        <MenuItem style={{ display:this.state.menuattendance }}>Departmental atendance  <Link to ="./Daily_attendance" data-tip data-for="leave6Tip"/></MenuItem>
                        <ReactTooltip id="leave6Tip" place="top" effect="solid">Departmental attendance</ReactTooltip>
                  */}
                    </SubMenu>
                    <SubMenu title="Vehicle" icon={<FcAutomotive size={30}/>} style={{ display:this.state.divdisplay }} >
                    <ReactTooltip id="vehicleTip" place="top" effect="solid">Vehicle</ReactTooltip>

                        <MenuItem >Fuel<Link to ="./fuel" data-tip data-for="fuelTip"/></MenuItem>
                        <ReactTooltip id="fuelTip" place="top" effect="solid">Fuel detail</ReactTooltip>
                        <MenuItem >Repair/Maintenance<Link to ="./repair" data-tip data-for="repairTip"/></MenuItem>
                        <ReactTooltip id="repairTip" place="top" effect="solid">Repair and maintenance detail</ReactTooltip>
                        <MenuItem >Fuel receipt<Link to ="./fuelreceipt" data-tip data-for="receiptTip"/></MenuItem>
                        <ReactTooltip id="receiptTip" place="top" effect="solid">Fuel receipt</ReactTooltip>
                        <MenuItem > Engin Oil change <font style={{color:"red",fontface:"cursive",size:"8"}}>   ( New )</font> <Link to ="./EnginOil" data-tip data-for="OilTip"/> </MenuItem> 
                        <ReactTooltip id="OilTip" place="top" effect="solid">To receive automated email notifications for timely Oil changes </ReactTooltip>
                    </SubMenu>

                  <div  style={{display:this.state.divadmin2}}>
                  <MenuItem icon={<FaCarCrash size={30} />}>Vehicle Upkeep (Admin) <Link to ="./AdminVehicleupkeep" data-tip data-for="Vehicle Upkeep" /></MenuItem>
                  <ReactTooltip id="VHA" place="top" effect="solid">Vehicle Upkeep (Admin)</ReactTooltip>
                  </div>
                    <SubMenu title="Medical" icon={<FaClinicMedical size={30}  />} >
                    <ReactTooltip id="medicalTip" place="top" effect="solid">Medical</ReactTooltip>
                        <MenuItem >Reimbursement form <Link to ="./Medical" data-tip data-for="claimTip"/></MenuItem>
                        <ReactTooltip id="claimTip" place="top" effect="solid">Medical reimbursement form</ReactTooltip>
                        <MenuItem>Medical detail for self<Link to ="./MedicalDetailSelf" data-tip data-for="claim2Tip"/></MenuItem>
                        <ReactTooltip id="claim2Tip" place="top" effect="solid">Medical detail self</ReactTooltip>
                        <MenuItem>Medical detail for other<Link to ="././MedicalDetailOther" data-tip data-for="home3ip"/></MenuItem>
                        <ReactTooltip id="claim3Tip" place="top" effect="solid">Medical detail other</ReactTooltip>



                    </SubMenu>


{/*}                  <MenuItem icon={<FcContacts size={30}/>}>Contacts <Link to ="./contacts" data-tip data-for="ContactsTip"/></MenuItem>*/}
                  <MenuItem icon={<FcContacts size={30}/>} data-tip data-for="ContactsTip">Contact<a href="https://poultry-kandns.com/vcard" target="blank" ></a></MenuItem>
                  <ReactTooltip id="ContactsTip" place="top" effect="solid">Contacts</ReactTooltip>

                  <MenuItem icon={<FcNews size={30}/>}>Policies & Documents <Link to ="./Notifications" data-tip data-for="notiTip"/></MenuItem>
                  <ReactTooltip id="notiTip" place="top" effect="solid">Policies & Documents</ReactTooltip>

{/*}                  <MenuItem icon={<FcNews size={30}/>}>Purchase Requisition <Link to ="./pr" data-tip data-for="prTip"/></MenuItem>
                  <ReactTooltip id="prTip" place="top" effect="solid">Purchase Requistion</ReactTooltip>
*/}
{/*                  <MenuItem icon={<FcNews size={30}/>}>Chart <Link to ="./Medicalchart" data-tip data-for="Chart"/></MenuItem>
                  <ReactTooltip id="Chart" place="top" effect="solid">Chart</ReactTooltip>
*/}
              </Menu>
              </SidebarContent>
              <SidebarFooter>
              <p style={{ fontSize: '8pt', textAlign: 'center' }}> © {this.state.year} K&N's. All rights reserved.</p>
              </SidebarFooter>
            </ProSidebar>
          </div>
        );
      }
  }
export default Header2;
